import React from "react";
function MemoizeComponent() {
    return (
        <React.Fragment>
            <h5>Memorizzazione di un Componente</h5>
        </React.Fragment>
    );
}

export default MemoizeComponent;